<!-- =========================================================================================
	Tareas Alumno
========================================================================================== -->
<template>
  <div id="todo-app" class="vs-con-loading__container">
    <!-- <vs-alert color="danger" active="true" class="mt-1 mb-3">
      <h6
        style="font-weight: bolder; color:red; font-style: italic; font-size: 11px;"
      >
        Nota: En caso de tener algún problema, revisa que el traductor de tu
        navegador este desactivado y si aun así sigues teniendo problema, limpia
        el cache de tu navegador.
      </h6>
    </vs-alert> -->
    <div class="vx-row mt-base">
      <div
        class="vx-col w-full md:w-1/4 sm:w-1/2 mb-base"
        v-for="tarea in arrTareas"
        :key="tarea.asignatura"
      >
        <vx-card style="height: 34rem;">
          <div class="flex vx-row">
            
            <div class="vx-col w-full md:w-3/4 sm:w-1/2">
              <div style="font-size: 14px;font-weight: bold;">
                {{ tarea.asignatura }}
              </div>
              <div style="font-size: 10px;">Grupo: {{ tarea.nombreGrupo }}</div>
              <div style="font-size: 10px;">
                Profesor: {{ tarea.nombreProfesor }}
              </div>
            </div>
            <div class="vx-col w-full md:w-1/4 sm:w-1/2" style="text-align: right;">
              <i
                class="vs-icon notranslate icon-scale material-icons null"
                style="font-size: 34px; text-align: left;color: #3c77a5;"
                >assignment</i
              >
            </div>
          </div>

          <vs-divider></vs-divider>
          <div class="my-6" style="height:210px; overflow: scroll;">
            <p
              v-if="tarea.listadoTareas.length == 0"
              style="position: absolute;left: 50%;top: 50%;transform: translate(-50%,-50%);text-align: center;font-weight: bold;"
            >
              Por ahora, no tienes tareas pendientes
            </p>

            <div
              v-else
              style="background-color: #f7f7f7;padding: 8px 8px 8px 8px;"
              class="mb-4"
              v-for="detalleTarea in tarea.listadoTareas"
              :key="detalleTarea.idTarea"
            >
              <p style="font-size: 12px;font-weight: bold;color: #14ab04;">
                Fecha de entrega: <span>{{ detalleTarea.fechaEntrega }}</span>
              </p>
              <p>
                <router-link 
                     style="border-bottom: 1px solid;color: #3c4858;font-family: arial;text-decoration: none;font-size: 14px;font-weight: bold;"
											:to="'/detalle-tarea/' + detalleTarea.idTarea" 
								>
                 {{ detalleTarea.nombreTarea }}
								</router-link>
              </p>
            </div>
          </div>

          <vs-divider></vs-divider>

          <div class="flex vx-row text-right">
            <div class="vx-col w-full">
              <router-link :to="'/historico-tareas/' + tarea.idAsignatura" >
                <vs-button
                class="mt-4 shadow-sm small color: white;font-family: arial;text-decoration: none;font-size: 12px;"
                >  Historial de tareas
                </vs-button>
							</router-link>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  data() {
    return {
      estatusTareas: 1,
      clickNotClose: true,
      displayPrompt: false,
      todoIdToEdit: "",
      isSidebarActive: true,
      windowWidth: window.innerWidth,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
      },
      arrTareas: [],
    };
  },

  watch: {
    
  },
  computed: {
   
  },
  methods: {
    getTasks(estatus) {
      let estatusRegistros = estatus;
      if (estatusRegistros == null || estatusRegistros == undefined) {
        estatusRegistros = 1;
      }
      fetch(`${this.$BASE.baseUrl}api/ObtenerTareas/1/${estatusRegistros}/0`, {
        method: "GET",
        headers: {
          Authorization: sessionStorage.getItem("token"),
          plataforma: 2,
        },
      })
        .then((rs) => rs.json())
        .catch((error) => console.log("error: ", error))
        .then((rs) => {
          if (rs.status === 200) {
            this.arrTareas = rs.result;
          }
        });
    },

   
  },
  components: {
     VuePerfectScrollbar,
  },
  created() {
    this.getTasks(this.estatusTareas);
  },
  
};
</script>

<style lang="scss">
@import "@/assets/scss/vuesax/apps/todo.scss";

.tarea-filters-scroll-area {
  position: relative;
  margin: auto;
  width: 100%;
  height: calc(100% - 5px);
}
</style>
